import { enableProdMode } from '@angular/core';
import localeSv from '@angular/common/locales/sv';

import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { applicationConfig } from 'app/app.config';
import { registerLocaleData } from '@angular/common';
import { bootstrapApplication } from '@angular/platform-browser';

import * as Sentry from '@sentry/angular-ivy';
import { awareSentryBeforeSend } from '@appbolaget/sentry';

Sentry.init({
    dsn: environment.sentry.dsn,
    integrations: [
        new Sentry.BrowserTracing({
            // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
            tracePropagationTargets: ['localhost', /^https:\/\/sentry\.appbolaget\.dev\/api/],
            routingInstrumentation: Sentry.routingInstrumentation,
        }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: environment.production ? 0.3 : 1.0,
    beforeSend: awareSentryBeforeSend,
});

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, applicationConfig).catch((err) => console.log(err));

registerLocaleData(localeSv);
